import React from 'react';
import { useLocation } from 'react-router-dom';
import { SycaiLogo } from './BrandIcons';

/**
 * M5.4 D7. develop puts the page title in white at the left of the header band, beside the
 * logo and the Upload control (reference 01); 3.13 centres it in orange. This renders both
 * halves into Table.tsx:127's `absolute left-0` slot and brand.css hides the centred
 * DataTable.Title.
 *
 * Gated on the route, not on the caller's argument count. appConfig.whiteLabeling
 * .createLogoComponentFn feeds WorkList.tsx AND Header.tsx, so an ungated title renders in
 * the viewer header too (plan D-12). WorkList passes one argument and Header two, which
 * would also discriminate -- but that is an upstream implementation detail with no contract
 * behind it and nothing at the call site to reveal it. Both call sites render inside
 * App.tsx's BrowserRouter, so the hook is legal in both.
 *
 * The string duplicates WorkList.tsx:161's hardcoded `title={'Study List'}` -- upstream's is
 * not translated either. If upstream ever i18n's it, this copy has to follow.
 *
 * text-foreground, not the inheritance the plan assumed: none of Table.tsx's, DataTable.tsx's
 * or WorkList.tsx's wrapping elements up to <html> carry a foreground-setting class, so an
 * unset color here rendered browser-default black on navy -- confirmed via computed style,
 * not assumed. Not .text-primary either, though it resolves to the same hsl(var(--foreground))
 * (brand.css D1): this span also carries text-[20px], which is the exact compound brand.css's
 * own D7 rule matches to hide the CENTRED title, so .text-primary here would vanish this one
 * too. text-foreground is a distinct Tailwind utility already declared upstream (tailwind.
 * config.js's `foreground`), so no fork CSS rule is needed for it.
 */
export function StudyListBrand(): JSX.Element {
  const { pathname } = useLocation();

  return (
    <div className="flex items-center gap-6">
      <SycaiLogo />
      {pathname === '/' ? (
        <span className="text-foreground text-[20px] font-medium">Study List</span>
      ) : null}
    </div>
  );
}

export default StudyListBrand;
